import { render, staticRenderFns } from "./BulkAssetsUpload.vue?vue&type=template&id=9954fe1e&scoped=true&"
import script from "./BulkAssetsUpload.vue?vue&type=script&lang=ts&"
export * from "./BulkAssetsUpload.vue?vue&type=script&lang=ts&"
import style0 from "./BulkAssetsUpload.vue?vue&type=style&index=0&id=9954fe1e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9954fe1e",
  null
  
)

export default component.exports